const sizeVariants = {
    8: 'w-[8px] h-[8px] text-icon-8',
    10: 'w-[10px] h-[10px] text-icon-10',
    12: 'w-[12px] h-[12px] text-icon-12',
    16: 'w-[16px] h-[16px] text-icon-16',
    18: 'w-[18px] h-[18px] text-icon-18',
    20: 'w-[20px] h-[20px] text-icon-20',
    24: 'w-[24px] h-[24px] text-icon-24',
    28: 'w-[28px] h-[28px] text-icon-28',
    32: 'w-[32px] h-[32px] text-icon-32',
    36: 'w-[36px] h-[36px] text-icon-36',
    40: 'w-[40px] h-[40px] text-icon-40',
    48: 'w-[48px] h-[48px] text-icon-48',
    64: 'w-[64px] h-[64px] text-icon-64',
    80: 'w-[80px] h-[80px] text-icon-80',
    96: 'w-[96px] h-[96px] text-icon-96'
};
const iconSizes = Object.keys(sizeVariants);
export { iconSizes, sizeVariants };
